import { useState } from 'react'
import { useTranslation } from 'react-i18next';

import Close from '../../assets/Close.svg';
import Loader from '../Loader/Loader';
import PingCard from '../PingCard/PingCard';
import Region from '../Region/Region';
import './Modal.scss';

type ModalProps = {
    rtl: boolean
    game: any
    handleCancel: (value: boolean) => void
}

function Modal({ rtl, game, handleCancel }: ModalProps) {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [currentRegion, setCurrentRegion] = useState('');

    const handleSelect = (value: string) => {
        setCurrentRegion(value);
        setLoading(true);

        setTimeout(() => {
            setLoading(false);
        }, 2000)
    }

    return (
        <>
            <div className='Modal__backdrop'></div>
            <div className='Modal__container' style={{ height: loading ? '272px' : '452px' }}>
                <img src={Close} alt='Close' className='closeIcon' style={{ float: rtl ? "left" : "right" }} onClick={() => handleCancel(false)} />
                {(!loading && currentRegion.length === 0) ? (
                    <Region rtl={rtl} title={t('select_Region')} handleSelect={handleSelect} />
                ) : (loading && currentRegion.length > 0 ?
                    <Loader loading={loading} rtl={rtl} /> : (
                        <PingCard rtl={rtl} game={game} currentRegion={currentRegion} />
                    )
                )}
            </div>
        </>
    )
}

export default Modal